import { GringottsConstants } from "./constants";

export const branchAlphaNumericSort = (a, b) => {
    const sectorNumberA = isEqual(GringottsConstants.notAvailable, a.sectorNumber) ? '' : a.sectorNumber;
    const sectorNumberB = isEqual(GringottsConstants.notAvailable, b.sectorNumber) ? '' : b.sectorNumber;
    const isaAlphabet = isNaN(Number(sectorNumberA));
    const isbAlphabet = isNaN(Number(sectorNumberB));
    if (!sectorNumberA) {
        return 1;
    }
    if (!sectorNumberB) {
        return -1;
    }
    if (isaAlphabet && isbAlphabet) {
        sectorNumberA.localeCompare(sectorNumberB)
    }
    else if (isaAlphabet) {
        return -1;
    }
    else if (isbAlphabet) {
        return 1;
    }
    return sectorNumberA.localeCompare(sectorNumberB);
}

const isEqual = (value1: string, value2: string): boolean => {
    if (!value1 || !value2) return false;
    return value1.toLocaleLowerCase() === value2.toLocaleLowerCase();
}